import { CheckboxProps } from "antd";
import { KCheckBoxStyled } from "./styles";

export const KCheckBox: React.FC<CheckboxProps> = (props) => (
  <KCheckBoxStyled {...props} />
);